import {useMemo} from "react";

const useIsMobile = (): boolean =>
  useMemo<boolean>(
    () => /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
    []
  );
export default useIsMobile;
